import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {assignAccountEntitlementsStateSelector} from './assign-account-entitlements-state.slice';

import type {CachedTableCacheSelector, CachedTableDataSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {EntitlementsFilters, ResourceView} from 'src/modules/entitlements/typedef';

export const assignAccountEntitlementsSlice = getCachedTableDataSlice<
    ResourceView[],
    undefined,
    undefined,
    EntitlementsFilters
>('assignAccountEntitlements');

export const assignAccountEntitlementsActions = assignAccountEntitlementsSlice.actions;
export const assignAccountEntitlementsCacheSelector: CachedTableCacheSelector<ResourceView[]> = state =>
    state.accountPage.assignEntitlements.result.cache;
export const assignAccountEntitlementsDataSelector: CachedTableDataSelector<ResourceView[]> = state =>
    state.accountPage.assignEntitlements.result;

export const assignAccountEntitlementsResultSelector = getCachedTableResultSelector(
    assignAccountEntitlementsCacheSelector,
    assignAccountEntitlementsStateSelector,
);
